// extracted by mini-css-extract-plugin
export var games = "index-module--games--UlQJ-";
export var version = "index-module--version--OBqSG";
export var createCustomRoom = "index-module--createCustomRoom--dPLwC";
export var rooms = "index-module--rooms--XmPXr";
export var room = "index-module--room--0MtFC";
export var info = "index-module--info--xAkZJ";